import { Loader } from 'Components';
import { useState } from 'react';

export const useLoader = (
  scale?: string,
  sx?: any,
  size?: number,
  loading?: boolean
) => {
  const loader = <Loader scale={scale} sx={sx} size={size} />;
  const [isLoading, setIsLoading] = useState<boolean>(
    loading === undefined ? true : false
  );

  return { isLoading, setIsLoading, loader };
};
